import classNames from "classnames";

export function CSVDownload(props: {
	onClick: () => void;
	is_loading: boolean;
}) {
	return (
		<button
			className={classNames(
				"manual-link ml-auto flex items-center gap-2",
				{
					"input-disabled": props.is_loading,
				}
			)}
			onClick={() => {
				if (props.is_loading) {
					return;
				}
				props.onClick();
			}}
		>
			<i className="fas fa-file-download"></i>
			<div>Download CSV</div>
		</button>
	);
}
